
import React, { ReactElement, ReactNode } from 'react';
import { Grid, Input, Menu } from 'semantic-ui-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


const Paginator = (props) => {

    const {
        changePage,
        first,
        isEmpty,
        last,
        pageNumber,
        totalPages
    } = props;

    if(isEmpty) {
        return null;
    }

    const getItems = () => {

        const checkInputValue = (value: string, target: { value: string }, callback: Function): void => {
            if(!value.match(/[0-9]/)) {
                target.value = '';
            } else {
                callback();
            }
        };

        const handleChangePage = (...args) => {
            const [ , { new_page_number } ] = args;

            if(new_page_number < 1 || new_page_number > totalPages) {
                return null;
            }
            changePage(+new_page_number - 1);
        };

        const handleInputBlur = e => {
            const {
                value: new_page_number
            } = e.target;

            checkInputValue(new_page_number, e.target, () => handleChangePage(null, { new_page_number }));
        };

        const handleKeyUp = e => {
            if(e.key === 'Enter') {
                checkInputValue(e.target.value, e.target, () => handleChangePage(null, { new_page_number: e.target.value }));
            }
        };

        const getArrowedItem = (isShown: boolean, arrowDirection: any, number: number): ReactNode => {

            if(!isShown) {
                return null;
            }

            return (
                <Menu.Item
                    as='a'
                    href='#'
                    icon
                    key={arrowDirection}
                    new_page_number={String(number)}
                    onClick={handleChangePage}
                >
                    <FontAwesomeIcon icon={arrowDirection} size="sm" />
                </Menu.Item>
            );
        };

        const getItem = (number: number | null, isInput?: boolean | null, isActive?: boolean): ReactElement => (
            <Menu.Item
                as='a'
                href='#'
                active={isActive}
                // Key is set to Math.random() for a while
                key={Math.random()} // TODO
                new_page_number={String(number)}
                onClick={isInput ? () => {} : (e, data) => handleChangePage(e, data)}
            >
                {
                    isInput ?
                        <Input
                            className='paginator_breadcrumbs'
                            new_page_number={String(number)}
                            onBlur={handleInputBlur}
                            onKeyUp={handleKeyUp}
                            placeholder='...'
                        /> :
                        number
                }
            </Menu.Item>
        );

        const getPreviousPage = (currentPage: number): ReactNode | ReactElement => {
            if(pageNumber < 2) {
                return null;
            }
            return getItem(currentPage - 1);
        };

        const getCurrentPage = (currentPage: number): ReactElement => {
            return getItem(currentPage, null, true);
        };

        const getNextPage = (currentPage: number): ReactNode | ReactElement => {
            if(totalPages - currentPage <= 1) {
                return null;
            }
            return getItem(currentPage + 1);
        };


        return [
            getArrowedItem(!first, 'chevron-left', pageNumber),
            getPreviousPage(pageNumber + 1),
            getCurrentPage(pageNumber + 1),
            getNextPage(pageNumber + 1),
            getArrowedItem(!last, 'chevron-right', pageNumber + 2)
        ];
    };

    return (
        <Grid columns={1}>
            <Grid.Row>
                <Grid.Column>
                    <Menu floated='right' pagination>
                        { getItems() }
                    </Menu>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
};

export default Paginator;